export default import.meta.ROLLUP_FILE_URL_BfISQoDiQpAd$yOpYUn88g